// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2svof","colBig":"styles_colBig__3xTWB","colSmall":"styles_colSmall__VDpnG"};